import { useEffect, useState } from 'react';

import axios from 'axios';
import { prop, sortBy } from 'ramda';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { updateProposalLandingSettings } from 'store/itinerariesItem/thunks';
import axiosApi from 'utils/axios';

import { IProposalSettings } from './index';

function useProposalSettings({ settings = {}, id, onClose }: IProposalSettings) {
  const dispatch = useDispatch();
  const [selectedLanguage, setSelectedLanguage] = useState<string | number | null>(null);
  const [locales, setLocales] = useState<{ label: string; value: string }[]>([]);
  const {
    control,
    handleSubmit,
    formState: { isDirty, isSubmitted },
  } = useForm({
    defaultValues: settings,
  });

  const languageChangeHandler = (option: string | number | null) => setSelectedLanguage(option);

  useEffect(() => {
    axiosApi
      .get('/refs/proposal_languages', { transformResponse: axios.defaults.transformResponse })
      .then(({ data }) => {
        const defaultLanguage = settings?.language || 'en';
        const options = Object.keys(data).map((language) => {
          const option = {
            label: data[language],
            id: language,
            name: data[language],
            value: language,
          };
          if (language == defaultLanguage) {
            setSelectedLanguage(option.id);
          }
          return option;
        });
        setLocales(sortBy(prop('label'))(options));
      });
  }, []);

  const submitHandler = (byDefault: boolean) =>
    handleSubmit((data) => {
      dispatch(
        updateProposalLandingSettings(id, {
          ...data,
          byDefault,
        }),
        // @ts-ignore
      ).then(onClose);
    });

  return {
    onClose,
    submitHandler,
    languageChangeHandler,
    selectedLanguage,
    locales,
    control,
    isDirty,
    isSubmitted,
  };
}

export default useProposalSettings;
